module.exports = __webpack_public_path__ + "img/jn-back.9127f101.png";